import { MULTI_SELECT_COLUMN_ID } from '../createSelectableColumn';
import { TableConfigurationMenuColumnInstance } from './types';

export const getLabel: <D extends Record<string, unknown>>(
  column: TableConfigurationMenuColumnInstance<D>
) => string | undefined = (column) => {
  return typeof column.Header === 'string' ? column.Header : column.label;
};

const blocklistColumnIds = [MULTI_SELECT_COLUMN_ID];

export const setHiddenInMenuForColumns = <D extends Record<string, unknown>>(
  columns: TableConfigurationMenuColumnInstance<D>[]
): TableConfigurationMenuColumnInstance<D>[] =>
  columns.map((column) => {
    const isIncludedInBlockList = blocklistColumnIds.includes(column.id);
    const isWithoutLabel = !getLabel(column);

    if (isIncludedInBlockList || isWithoutLabel) column.hiddenInMenu = true;
    return column;
  });

export const removeHiddenColumnsFromTheEnd = <
  D extends Record<string, unknown>
>(
  columns: TableConfigurationMenuColumnInstance<D>[]
): TableConfigurationMenuColumnInstance<D>[] => {
  const columnsCopy = [...columns];
  let noMoreHiddenColumns = false;
  for (let i = columnsCopy.length - 1; i >= 0; i--) {
    if (noMoreHiddenColumns) break;

    if (columnsCopy[i].hiddenInMenu) {
      columnsCopy.pop();
    } else {
      noMoreHiddenColumns = true;
    }
  }

  return columnsCopy;
};

export const getValidColumns = <D extends Record<string, unknown>>(
  columns: TableConfigurationMenuColumnInstance<D>[]
): TableConfigurationMenuColumnInstance<D>[] => {
  setHiddenInMenuForColumns(columns);
  return removeHiddenColumnsFromTheEnd(columns);
};

export const isColumnSticky = <D extends Record<string, unknown>>(
  column: TableConfigurationMenuColumnInstance<D>
): boolean => {
  if (column.sticky) return true;
  if (column.parent) {
    return isColumnSticky<D>(column.parent);
  }
  return false;
};

export const isColumnDisabled = <D extends Record<string, unknown>>(
  column: TableConfigurationMenuColumnInstance<D>
): boolean => {
  return isColumnSticky<D>(column) || !!column.disableConfiguration;
};
